<!-- Modalbox: survey settings -->
<p-dialog [(visible)]="visible" (onHide)="onClose()" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false"
  [header]="'MODALBOXES.TITLE_SURVEY_SETTINGS' | translate">
  <form [formGroup]="surveySettingsFormGroup">
    <div class="row">
      <div class="field-wr col-12">
        <label class="block text-sm mb-1" for="surveyId">{{ 'MODALBOXES.LABEL_SURVEY_SETTINGS' | translate }}:</label>

        <app-custom-dropdown
          data-testid="survey-settings-survey-dropdown"
          class="surveys-dropdown"
          [compactUi]="false"
          [placeholder]="'MODALBOXES.PLACEHOLDER_SURVEY_SETTINGS_DROPDOWN' | translate"
          [options]="surveysList"
          optionLabel="text"
          optionValue="id"
          [isMultiselect]="false"
          [showSelectionChips]="true"
          [showClear]="false"
          [showSearchbox]="true"
          [searchMode]="'remote'"
          [pageSize]="surveysRowsPerPageOption"
          [totalCount]="surveysTotalRecords"
          [totalPages]="getSurveysTotalPages()"
          formControlName="survey"
          (onLazyLoad)="onLazyLoadSurveys($event)">
        </app-custom-dropdown>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <button data-testid="survey-settings-cancel-btn" type="button" class="btn outline-btn" (click)="onClose()">{{ 'MODALBOXES.BTN_CANCEL_SURVEY_SETTINGS' | translate }}</button>
    <button data-testid="survey-settings-save-btn" type="button" class="btn primary-btn" (click)="onSurveySettingsSave()" [disabled]="surveySettingsFormGroup.invalid">{{ 'MODALBOXES.BTN_SAVE_SURVEY_SETTINGS' | translate }}</button>
  </ng-template>
</p-dialog>
